import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';

/**
 * Primary tab of a WM Data Profile form: the profile block and the User Defined Codes block. The
 * codes are WMCODES lookups configured in the screen's Layout.js, so there is no client-side option
 * loading to do here.
 *
 * Props: layoutId / layoutName (the dynamic-form customisation keys, unique per screen) and
 * defaultFormSchema, plus the usual formFields / setformFields / formRefs / handleFieldChange.
 */
function DataProfilePrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // FormField calls onFormLoad() unconditionally in a finally block with no default and no guard
    // (FormField.js:256), so it is a required prop even when there is nothing to load. The lookups on
    // this form fetch their own data, hence the no-op.
    const handleFormLoad = useCallback(() => {
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId={props.layoutId}
                layoutName={props.layoutName}
                defaultFormSchema={props.defaultFormSchema}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(DataProfilePrimaryTab);
